import { cachedFetch } from '../kpi-consolides/hooks/useCachedFetch';
import type { DeBelemSummary } from './types';

/**
 * Client API du tab De Belem. Réutilise `cachedFetch` du module
 * kpi-consolides : la Map de cache est partagée mais les clés (URL +
 * querystring) ne se chevauchent pas avec celles d'Adélie. Bonus : un
 * `clearClientCache()` (déjà câblé dans `stores/auth.ts::clear`, cf
 * SECURITY.md §19.5/§19.11 OBS-2) purge les deux d'un coup à la
 * déconnexion.
 *
 * Sécurité : Bearer JWT passé explicitement (pattern identique à kpi-
 * consolides). Si le backend renvoie 401, on échoue en clair - la
 * prochaine navigation ré-enchaîne le flow d'auth standard.
 */

export interface DeBelemSummaryParams {
  dateFrom: string; // YYYY-MM-DD
  dateTo: string;
}

export const deBelemApi = {
  summary: (accessToken: string, params: DeBelemSummaryParams) =>
    cachedFetch<DeBelemSummary>(
      '/api/v1/de-belem',
      { dateFrom: params.dateFrom, dateTo: params.dateTo },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    ),
};
